import React from "react";
import { NavLink } from "react-router-dom";
import {
  LayoutDashboard, GanttChartSquare, Grid3x3, Users, MonitorDot,
  CalendarRange, CalendarClock, UserX, Cpu, Briefcase,
} from "lucide-react";

const nav = [
  { to: "/", label: "Command", icon: LayoutDashboard, end: true },
  { to: "/schedule", label: "Gantt Timeline", icon: GanttChartSquare },
  { to: "/coverage", label: "Coverage Heatmap", icon: Grid3x3 },
  { to: "/professions", label: "Professions", icon: Briefcase },
  { to: "/agents", label: "Agents", icon: Users },
  { to: "/workstations", label: "Workstations", icon: MonitorDot },
  { to: "/builder", label: "Master Week", icon: CalendarRange },
  { to: "/term", label: "Term Planner", icon: CalendarClock },
  { to: "/absences", label: "Absences", icon: UserX },
];

export function Sidebar() {
  return (
    <aside className="w-60 shrink-0 h-screen sticky top-0 bg-surface border-r border-line flex flex-col">
      <div className="px-5 h-16 flex items-center gap-3 border-b border-line">
        <div className="w-9 h-9 rounded-sm bg-primary/15 border border-primary/40 flex items-center justify-center">
          <Cpu className="w-5 h-5 text-primary" />
        </div>
        <div>
          <div className="head text-sm font-bold tracking-tight text-ink leading-none">
            ORchestra
          </div>
          <div className="mono text-[10px] text-faint tracking-wider mt-1">CP-SAT ENGINE</div>
        </div>
      </div>

      <nav className="flex-1 px-3 py-4 space-y-1">
        {nav.map(({ to, label, icon: Icon, end }) => (
          <NavLink
            key={to}
            to={to}
            end={end}
            data-testid={`nav-${label.toLowerCase().replace(/\s+/g, "-")}`}
            className={({ isActive }) =>
              `group flex items-center gap-3 px-3 h-9 rounded-sm text-sm transition-colors duration-150 ${
                isActive
                  ? "bg-primary/15 text-ink border border-primary/30"
                  : "text-muted hover:text-ink hover:bg-white/5 border border-transparent"
              }`
            }
          >
            <Icon className="w-4 h-4 shrink-0" />
            <span className="tracking-tight">{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="px-5 py-4 border-t border-line">
        <div className="mono text-[10px] text-faint leading-relaxed">
          Google OR-Tools · CP-SAT
          <br />
          5-min slots · 7-day horizon
        </div>
      </div>
    </aside>
  );
}
